import { createTheme } from '@mui/material/styles';

// Brand Colors
const brandColors = {
  primary: '#01273B',      // Main brand blue
  secondary: '#FF4449',    // Deep red accent
  white: '#FFFFFF',        // Pure white
  
  // Additional accent colors
  blue: '#5B7BD4',
  teal: '#469A9E',
  green: '#5E965D',
  olive: '#ABA03E',
  gold: '#EDB847',
  orange: '#E57147',
  pink: '#CF559C',
  purple: '#845EAD',
  
  // Metric-specific colors for consistent visualization
  awareness: '#5B7BD4',      // Blue - represents visibility/recognition
  highInterest: '#5E965D',   // Green - represents positive engagement
  theaterIntent: '#E57147',  // Orange - represents action/intent
  willingToPay: '#EDB847'    // Gold - represents value/money
};

// Create theme
export const theme = createTheme({
  palette: {
    primary: {
      main: brandColors.primary,
      light: '#1a3a4f',
      dark: '#001a2a',
      contrastText: brandColors.white,
    },
    secondary: {
      main: brandColors.secondary,
      light: '#ff6b6f',
      dark: '#cc3333',
      contrastText: brandColors.white,
    },
    background: {
      default: '#f8f9fa',
      paper: brandColors.white,
    },
    text: {
      primary: brandColors.primary,
      secondary: '#6c757d',
    },
    success: {
      main: brandColors.green,
    },
    warning: {
      main: brandColors.gold,
    },
    error: {
      main: brandColors.secondary,
    },
    info: {
      main: brandColors.blue,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: brandColors.primary,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: brandColors.primary,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: brandColors.primary,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: brandColors.primary,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      color: brandColors.primary,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      color: brandColors.primary,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none',
          boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        disablePortal: true,  // Prevents fly-in animation from top of viewport
      },
    },
  },
});

export { brandColors };
